import { useQuery } from "@tanstack/react-query";
import { blogService } from "@/services/blog";
import { blogKeys } from "./queryKeys";

/** Categorias do blog com contagem de posts publicados. */
export const useBlogCategories = () =>
  useQuery({
    queryKey: blogKeys.categories(),
    queryFn: () => blogService.listCategories(),
  });
